import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ApiResponse {
  status: number;
  message: string;
  data?: any;
  pagination?: any;
  error?: any;
  url?: string;
  token?: string;
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(public http: HttpClient, private router: Router) { }

  // GET method
  public get(path: string, params: HttpParams = new HttpParams()): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(environment.api_url + path, { params })
      .pipe(catchError(error => this.handleError(error)));
  }

  // GET method with headers
  public getWithRequestHeader(path: string, params: HttpParams = new HttpParams(), headers: HttpHeaders = new HttpHeaders()): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(environment.api_url + path, { params, headers })
      .pipe(catchError(error => this.handleError(error)));
  }

  // PUT method
  public put(path: string, body: Object = {}): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(environment.api_url + path, body)
      .pipe(catchError(error => this.handleError(error)));
  }

  // PUT method with headers
  public putWithHeaders(path: string, body: Object = {}, headers: HttpHeaders = new HttpHeaders()): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(environment.api_url + path, body, { headers })
      .pipe(catchError(error => this.handleError(error)));
  }

  // POST method
  public post(path: string, body: Object = {}): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(environment.api_url + path, body)
      .pipe(catchError(error => this.handleError(error)));
  }

  // POST method
  public postWithBodyAndParams(path: string, body: Object = {} , params: HttpParams = new HttpParams()): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(environment.api_url + path, body, {params: params} )
      .pipe(catchError(error => this.handleError(error)));
  }

  // POST method with headers
  public postWithHeaders(path: string, body: Object = {}, headers: HttpHeaders = new HttpHeaders()): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(environment.api_url + path, body, { headers })
      .pipe(catchError(error => this.handleError(error)));
  }

  // DELETE method
  public delete(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.delete(environment.api_url + path, { params })
      .pipe(catchError(error => this.handleError(error)));
  }

  // General error handling method
  private handleError(error: any): Observable<never> {
    console.error('API Error:', error);

    // Rethrow the error to be handled by the interceptor
    return throwError(() => error);
  }
}
